var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#8962D0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5854_61277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 6.875C13.875 7.35898 14.266 7.75 14.75 7.75H15.625C16.109 7.75 16.5 8.14102 16.5 8.625C16.5 9.10898 16.109 9.5 15.625 9.5H6.875C6.39102 9.5 6 9.89102 6 10.375C6 10.859 6.39102 11.25 6.875 11.25H15.625C17.0742 11.25 18.25 10.0742 18.25 8.625C18.25 7.17578 17.0742 6 15.625 6H14.75C14.266 6 13.875 6.39102 13.875 6.875ZM15.625 16.5C15.625 16.984 16.016 17.375 16.5 17.375H17.375C18.8242 17.375 20 16.1992 20 14.75C20 13.3008 18.8242 12.125 17.375 12.125H6.875C6.39102 12.125 6 12.516 6 13C6 13.484 6.39102 13.875 6.875 13.875H17.375C17.859 13.875 18.25 14.266 18.25 14.75C18.25 15.234 17.859 15.625 17.375 15.625H16.5C16.016 15.625 15.625 16.016 15.625 16.5ZM9.5 20H10.375C11.8242 20 13 18.8242 13 17.375C13 15.9258 11.8242 14.75 10.375 14.75H6.875C6.39102 14.75 6 15.141 6 15.625C6 16.109 6.39102 16.5 6.875 16.5H10.375C10.859 16.5 11.25 16.891 11.25 17.375C11.25 17.859 10.859 18.25 10.375 18.25H9.5C9.01602 18.25 8.625 18.641 8.625 19.125C8.625 19.609 9.01602 20 9.5 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5854_61277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathe);
export default __webpack_public_path__ + "static/media/breathe.0c19b15c479adf162b27201c7abe356c.svg";
export { ForwardRef as ReactComponent };